import * as SentryIo from '@sentry/react';
import { Integrations } from "@sentry/tracing";

import { Route } from 'react-router-dom';
import { createBrowserHistory } from "history";


export class Sentry {
  static readonly instance: Sentry = new Sentry();
  
  private _history = createBrowserHistory({basename: process.env.PUBLIC_URL});
  private _SentryRoute = SentryIo.withSentryRouting(Route);

  get history() {
    return this._history;
  }

  get SentryRoute() {
    return this._SentryRoute;
  }

  initialize() {
    SentryIo.init({
      environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
      dsn: process.env.REACT_APP_SENTRY_DSN,
      release: process.env.REACT_APP_SENTRY_RELEASE, //'servico@' + process.env.npm_package_version,
      integrations: [new Integrations.BrowserTracing({
        routingInstrumentation: SentryIo.reactRouterV5Instrumentation(this.history),
      })],
      tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACING ?? "0")
    });
  }

  atualizarDados(keycloak: Keycloak.KeycloakInstance) {
    const username = (keycloak.tokenParsed as any)?.prefered_username as string|undefined;
    const idInstitucional = (keycloak.tokenParsed as any)?.id_institucional as string|undefined
    const email = (keycloak.tokenParsed as any)?.email as string|undefined

    SentryIo.setUser({
      "id": idInstitucional,
      "username": username,
      "email": email
    });
  }
}